// client/helper-methods.ts
import { Camera, CameraResultType } from "@capacitor/camera";
import { dataURLtoFile } from "../db/files";
var download = (contents, name) => {
  const a = document.createElement("a");
  a.href = "data:attachment/csv," + encodeURIComponent(contents);
  a.target = "_blank";
  a.download = name || "download.csv";
  document.body.appendChild(a);
  a.click();
  requestAnimationFrame(() => document.body.removeChild(a));
};
var askForTextFile = (forcedEncoding) => {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".txt,.csv,.json";
    input.onchange = () => {
      const fr = new FileReader();
      fr.onload = (e) => {
        if (fr.result)
          resolve(fr.result);
        else
          reject();
      };
      fr.onerror = (e) => reject(e.target.error);
      fr.onabort = () => reject();
      fr.readAsText(
        input.files[0],
        forcedEncoding || (navigator.platform.indexOf("Linux") !== -1 || navigator.platform.indexOf("Mac") !== -1 ? "UTF-8" : "CP1252")
      );
    };
    input.click();
  });
};
var askForFile = (options) => {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    if (options?.acceptMultipleFiles)
      input.setAttribute("multiple", "");
    input.type = "file";
    if (options?.acceptFileTypes)
      input.accept = options.acceptFileTypes;
    input.onchange = () => {
      resolve(input.files);
    };
    input.click();
  });
};
var askForImage = async (options = { quality: 100, resultType: CameraResultType.DataUrl }) => {
  try {
    return await Camera.getPhoto({ ...options, resultType: CameraResultType.DataUrl }).then(
      (cameraPhoto) => dataURLtoFile(cameraPhoto.dataUrl, "image.png")
    );
  } catch (e) {
    if (e.message?.includes("User cancelled"))
      throw e;
    console.warn("Couldn't use Camera.getPhoto, will fallback to askForFile instead. Error: ", e);
    return askForFile({ acceptFileTypes: ".jpg,.jpeg,.png,.webp" }).then((files) => files[0]);
  }
};
export {
  askForFile,
  askForImage,
  askForTextFile,
  download
};
